export const manifest = {
  screens: {
    scr_l4yeux: { name: "Home", route: "/" },
  },
}
